import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import Validator from 'validatorjs';

import { FormControl } from '../../../../facturotopia';
import Base64FileUpload from '../../../../facturotopia/base64-file-upload/Base64FileUpload';

class EmisorFiscalCredentialsForm extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { type } = this.props;
    const keyPairType = type.toString().toLowerCase();

    const rules = {
      [`${keyPairType}_key`]: ['required'],
      [`${keyPairType}_cer`]: ['required'],
      [`${keyPairType}_password`]: ['required', 'min:4']
    }

    this.state = {
      busy: false,
      validator: new Validator({}, rules),
      rules,
      confirmed: false,
      terms_accepted: false,
    };
  }

  componentDidMount() {
    this.validate(this.props.data);
  }

  validate(data) {
    const validator = new Validator(data, this.state.rules);

    validator.check();

    this.setState({
      validator,
      isValid:  validator.passes()
    });

    return validator;
  }

  handleOnChange = (value) => {
    const { confirmed } = this.state;

    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step: this.props.step,
      isValid:  validator.passes() && !!confirmed
    });
  }

  handleOnFileChange = (event) => {
    const { data } = this.props;

    this.handleOnChange({
      ...data,
      [event.name]: event
    });
  }

  handleOnPasswordChange = (value) => {
    const { data } = this.props;

    this.handleOnChange({
      ...data,
      ...value
    });
  }

  render() {
    const { inputs = {}, data } = this.props;
    const { validator, error, result } = this.state;

    return (
      <Form autoComplete="off">

        { !!error && this.renderError() }

        { !!result && this.renderResult() }

        <Base64FileUpload type="file"
          help="Selecciona el certificado (.cer)"
          accept=".cer"
          { ...inputs.cer }
          autoFocus={ true }
          validator={ validator }
          value={ data[inputs.cer.name] }
          onChange={ this.handleOnFileChange }
        />

        <Base64FileUpload type="file"
          help="Selecciona la llave privada (.key)"
          accept=".key"
          { ...inputs.key }
          autoFocus={ true }
          validator={ validator }
          value={ data[inputs.key.name] }
          onChange={ this.handleOnFileChange }
        />

        <FormControl type="password-preview"
          { ...inputs.password }
          validator={ validator }
          value={ data[inputs.password.name] }
          onChange={ this.handleOnPasswordChange }
        />

      </Form>
    )
  }
}

export default EmisorFiscalCredentialsForm;